import { render, staticRenderFns } from "./laModal.vue?vue&type=template&id=3458c2ba"
import script from "./laModal.vue?vue&type=script&lang=js"
export * from "./laModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports